<template>
  <section>
    <div class="infoEmpresa">
      <v-container class="contenedor">
        <span class="negrita">{{ $t('message.empresa.nombre') }} </span>
        <span>{{ empresa.dsempres }}</span>
        <span class="negrita separado">{{ $t('message.empresa.cif') }} </span>
        <span>{{ empresa.cdcif }}</span>
        <span class="negrita separado">{{ $t('message.empresa.tipo') }} </span>
        <span>{{ empresa.cdtipemp | tipoEmpresaName }}</span>
        <span class="negrita separado">{{ $t('message.empresa.direccion') }} </span>
        <span>{{ direccion }} ({{ this.empresa.cdprovin | provinciaName }})</span>
        <Boton
          id="btnSelectEmpresa"
          tipo="warning"
          tamano="sm"
          class="separado"
          :onclick="clickEmpresa"
          v-if="empresas.length > 1"
          small
          >Seleccionar otra empresa</Boton
        >
      </v-container>
    </div>

    <!-- Modal para la seleccion de empresa -->
    <Modal id="modalSelecEmpresa" :modalShow="modalShow" size="600">
      <template slot="title">
        <v-container fluid text-xs-center>
          <v-layout align-center justify-center>
            <v-flex xs4>
              <img src="@/resources/img/cnmc-logo.png" class="logo" />
            </v-flex>
            <v-flex xs8>
              <span class="titulo">{{ $t('message.login.titulo') }}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
      <v-container fluid text-xs-center>
        <div>
          <seleccion-empresa @changed="changeHandler" :empresas="empresas"> </seleccion-empresa>
        </div>
      </v-container>
    </Modal>
  </section>
</template>

<script>
import { SeleccionEmpresa, Boton, Modal } from '@/components';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'InfoEmpresa',
  props: {
    empresa: {
      type: Object,
      required: true
    }
  },
  components: {
    SeleccionEmpresa,
    Boton,
    Modal
  },
  data() {
    return {
      modalShow: false
    };
  },
  methods: {
    ...mapActions(['setEmpresaSelected']),
    changeHandler(empresa) {
      this.setEmpresaSelected(empresa);
      this.modalShow = false;
      this.$router.push('/');
    },
    clickEmpresa() {
      this.modalShow = true;
    }
  },
  computed: {
    ...mapGetters({
      empresas: 'empresas'
    }),
    direccion() {
      return this.empresa.dsdomici + ' ' + this.empresa.cdpostal + ' ' + this.empresa.dspoblac;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/resources/styles/variables.scss';
.separado {
  margin-left: 30px;
}

.infoEmpresa {
  border: 1px solid #ccc;
  border-width: 1px 0;
  text-align: center;
  background: $color-secondary;
  -webkit-box-shadow: 1px 2px 5px #ccc;
  box-shadow: 1px 2px 5px #ccc;
  padding: 5px;
}
.contenedor {
  padding: 0 24px;
}
.container {
  padding: 5px;
}

span.titulo {
  color: $color-text-secondary;
  font-size: 25px;
}
</style>
